<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-card dark min-height="250" color="blue-grey">
          <v-card-title> Copias Ticket </v-card-title>
          <v-card-subtitle>
            <label for="numTickets"
              >Cuantos tickets quieres imprimir al recibir la ropa?</label
            >
          </v-card-subtitle>
          <v-card-text>
            <div class="config__input-container">
              <input
                class="config__input config__input--sm"
                id="numTickets"
                type="number"
                min="0"
                max="2"
                v-model="computedNumTickets"
                @change="enableNumTicketEdit"
              />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              :disabled="isNumTicketsEditDisabled"
              @click="cancelNumTickets"
            >
              <v-icon small class="mr-1">mdi-close-thick</v-icon>
              Cancelar</v-btn
            >
            <v-btn
              small
              :disabled="isNumTicketsEditDisabled"
              @click="saveNumTickets"
            >
              <v-icon small class="mr-1">mdi-floppy</v-icon>
              Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// const { updateNewBillNumTickets, getSettingByName, setNewSetting } =
//   api.services.settingsService;
export default {
  data() {
    return {
      numTickets: 1,
      numTicketsSetting: null,
      isNumTicketsEditDisabled: true,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    computedNumTickets: {
      get: function () {
        return parseInt(this.numTickets);
      },
      set: function (value) {
        this.numTickets = parseInt(value);
      },
    },
  },
  methods: {
    ...mapActions(["showLoadingIndicator"]),
    updateNewBillNumTickets(){},
    getSettingByName(){},
    setNewSetting(){},
    saveNumTickets() {
      const self = this;
      self.showLoadingIndicator(true);
      const payload = this.makeNumTicketsPayload(this.computedNumTickets);
      const savedNumTickets = this.updateNewBillNumTickets(payload);
      setTimeout(() => {
        if (savedNumTickets) {
          self.showLoadingIndicator(false);
          this.isNumTicketsEditDisabled = true;
          this.getNumTicketsFromDB();
        }
      }, 500);
    },
    cancelNumTickets() {
      this.computedNumTickets = parseInt(this.numTicketsSetting.value);
    },
    enableNumTicketEdit() {
      const numTicketChanged =
        parseInt(this.computedNumTickets) !==
        parseInt(this.numTicketsSetting.value);
      if (numTicketChanged) this.isNumTicketsEditDisabled = false;
      else this.isNumTicketsEditDisabled = true;
    },
    makeNumTicketsPayload(numTickets) {
      const user = this.user;
      const payload = {
        idUsuario: user.id,
        name: "num_new_bill_tickets",
        value: numTickets,
        context: "preferencias_negocio",
        description:
          "Decidir cuantas copias del ticket de la venta imprimir. Por defecto 1, pero puede ser 0,1 ó 2",
      };
      return payload;
    },
    getNumTicketsFromDB() {
      const numTicketsSetting = this.getSettingByName("num_new_bill_tickets");
      if (!numTicketsSetting) {
        const payload = this.makeNumTicketsPayload(1);
        this.setNewSetting(payload);
      } else {
        this.numTicketsSetting = numTicketsSetting;
        this.computedNumTickets = parseInt(numTicketsSetting.value);
      }
    },
  },
  beforeMount() {
    this.getNumTicketsFromDB();
  },
};
</script>